import { useAuthStore } from '../store/useAuthStore';
import { EmployeeDashboard } from './Dashboard/EmployeeDashboard';
import { AdminDashboard } from './Dashboard/AdminDashboard';

export function Dashboard() {
  const { isAdmin } = useAuthStore();
  return isAdmin ? <AdminDashboard /> : <EmployeeDashboard />;
}
